
'use client'

/***
 *ßß
 * @file components/Counter/index.tsx
 * @description Counter component ßwill be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React, { useEffect, useState } from "react";
// import "./Counter.scss";
import classNames from "classnames";
import { T_KeyValue } from "@/types/app.type";
import { isEmptyObject } from "@/helpers/utils.helper";

type T_Props = {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  labels?: string;
  startDate?: any;
  targetDate?: string;
  datesJson?: string;
  variant?: string;
  size?: string;
  hide?: boolean;  // Hide Counter Component
}

const Counter = ({days=0, hours, minutes, seconds, size="text-counter-l", variant="text-counter-fg-default", startDate=(new Date()).toISOString(), targetDate, datesJson, labels="Days, Hours, Minutes, Seconds", hide=false}: T_Props) => {
  
  const [counterSegments, setCounterSegments] = useState<any>(null);
  const [counterStartDate, setCounterStartDate] = useState<string>(startDate);
  const [enableCounter, setEnableCounter] = useState<boolean>(false);
  const [fontSize, setFontSize] = useState<string>(size);
  const [delimFontSize, setDelimFontSize] = useState<string>(size);
  const [labelFontSize, setLabelFontSize] = useState<string>('text-[16px]');
  const [counterSegmentWidth, setCounterSegmentWidth] = useState<string>('w-[70px]');
  const [jsonArray, setJsonArray] = useState<any>([])
  // const [aDate, setAdate] = useState<any>({});
  // const [dates, setDates] = useState<any>([]);

  // const getDateObject = ({dateArray=[], effDate=(new Date()).toDateString()}: {dateArray: T_KeyValue[], effDate?: string}) => {
  //   //1.
  //   let itemsSorted = dateArray.slice().sort((a: T_KeyValue, b: T_KeyValue) => Date.parse(b.targetDate) - Date.parse(a.targetDate))
  //   //2. 
  //   return itemsSorted.find(item => Date.parse(item.targetDate) < Date.parse(effDate));
  // };

  // const justPassedDate = ({dateArray=[], effDate=(new Date()).toDateString()}: {dateArray: T_KeyValue[], effDate?: string}) => {
  //   return dateArray
  //           .filter(item => new Date(item?.startDate) < new Date(effDate)) // Keep only past dates
  //           .sort((a: T_KeyValue, b: T_KeyValue) => {
  //             let aDate: any = new Date();
  //             let bDate: any = new Date();
  //             if(a.startDate) {
  //               aDate = new Date(a?.startDate);
  //             }
  //             if(b.startDate) {
  //               bDate = new Date(b?.startDate);
  //             }
  //             return (bDate - aDate);
  //           })[0]; // Get the most recent past date
  // }

  const getCommingTargetDate = ({dateArray=[], effDate=(new Date())}: {dateArray: any, effDate?: string | Date}) => {
    // return dateArray?.[0]?.targetDate;
    // debugger;
    setJsonArray(dateArray);
    const counterDateObj =  (dateArray && Array.isArray(dateArray) ? dateArray : [])
      .filter((item: any) => ((new Date(item.startDate)).getTime() <= (new Date(effDate)).getTime() && (new Date(item.targetDate)).getTime() > (new Date(effDate)).getTime())) // Keep only past startDates
      .sort((a: any, b: any) => {
        let aDate: any = new Date();
        let bDate: any = new Date();
        if(a.startDate) {
          aDate = new Date(a?.startDate as string);
        }
        if(b.startDate) {
          bDate = new Date(b?.startDate as string);
        }
        return (bDate - aDate);
      }) // Sort in descending order
      // ?.at(0); // Get the date object of the most recent past startDate

      // counterDateObj?.push({
      //   "s": (new Date(dateArray?.[1]?.startDate)).getTime(), 
      //   "c": (new Date(effDate)).getTime(), 
      //   "t": (new Date(dateArray?.[1]?.targetDate)).getTime(),
      //   "s<=c": (new Date(dateArray?.[1]?.startDate)).getTime() <= (new Date(effDate)).getTime(),
      //   "t>c": (new Date(dateArray?.[1]?.targetDate)).getTime() > (new Date(effDate)).getTime(),
      //   "stz": (new Date(dateArray?.[1]?.startDate)).getTimezoneOffset(),
      //   "ttz": (new Date(dateArray?.[1]?.targetDate)).getTimezoneOffset(),
      //   "ctz": (new Date(effDate)).getTimezoneOffset(),
      // })
      // setAdate(counterDateObj);
      // setDates((dateArray && Array.isArray(dateArray) ? dateArray : [])?.filter((item: any) => (new Date(item.startDate) <= new Date(effDate) && new Date(item.targetDate) > new Date(effDate))) || [])
      setCounterStartDate(counterDateObj?.[0]?.startDate);
      return counterDateObj?.[0]?.targetDate;
  }

  const getCounter = ({data="{}", effDate=(new Date())}: {data: string | undefined, effDate?: string | Date})=>{
    /**
     * Format 1:
     * {
     *    startDate-1: targetDate-1,
     *    startDate-2: targetDate-2,
     *    .....: .....,
     *    startDate-n: targetDate-n
     * }
     * 
     * Format 2:
     * [
     *    {startDate: <some value>, targetDate: <some value>},
     *    {startDate: <some value>, targetDate: <some value>}
     * ]
     */
    const dt = new Date();
    dt.setDate(dt.getDate() + 7);
    const commingTargetDate = data ? getCommingTargetDate({dateArray: JSON.parse(data || "{}"), effDate}) : targetDate;
    // const aa = {"startDate": startDate, "targetDate": targetDate}
    // const commingTargetDate = getCommingTargetDate({dateArray: JSON.parse(data || JSON.stringify(aa))});
    const tDate = commingTargetDate ? new Date(commingTargetDate) : dt;
    const cDate = new Date();
    const secs = Math.floor((tDate.getTime() - cDate.getTime()) / 1000); //((days || 0) * 24 * 60 * 60) + ((hours || 0) * 60 * 60) + ((minutes || 0) * 60) + (seconds || 0);
    return secs;
  };

  const [counter, setCounter] = useState<number>(0);
  

  useEffect(()=>{
    setFontSize(size);
    setDelimFontSize(size);
    switch(size) {
      case 'text-counter-s':
        setLabelFontSize(`text-[0.875rem] leading-[1rem]`);
        setCounterSegmentWidth(`w-[35px]`);
        break;
      case 'text-counter-m':
        setLabelFontSize(`text-[1rem] leading-[1rem]`);
        setCounterSegmentWidth(`w-[45px]`);
        break;
      case 'text-counter-l':
        setLabelFontSize(`text-[1.125rem] leading-[1.125rem]`);
        setCounterSegmentWidth(`w-[65px]`);
        break;
      default:
        setLabelFontSize(`text-[1.625rem] leading-[1.25rem]`);
        setCounterSegmentWidth(`w-[90px]`);
        break;
    }
    setEnableCounter((()=>{
      if(!counterStartDate) {
        return false;
      }else if(counterStartDate && (new Date()) < (new Date(counterStartDate))) {
        return false;
      } else {
        return true;
      }
    })())

    setCounter(getCounter({data: datesJson ? datesJson : ((startDate: string="", targetDate: string="")=>{
      // console.log("llllll ------>>>>> ",startDate, targetDate);
      const sd = startDate?startDate?.toString()?.split(','):[];
      const td = targetDate?targetDate?.toString()?.split(','):[];
      const arr = sd && sd?.map((dt: string, index: number)=>{
        return { "startDate": dt, "targetDate": td?.[index]}
      });
      return JSON.stringify(arr);
    })(startDate, targetDate)}));
  }, [counterStartDate, datesJson, size, startDate, targetDate, new Date().getMinutes()]);

  // Third Attempts
  useEffect(() => {
    const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    (async () => {
      const cData = await (() => {
        return {
          days: Math.floor(counter / (24 * 60 * 60)),
          hours: Math.floor((counter % (24 * 60 * 60)) / (60 * 60)),
          minutes: Math.floor(((counter % (24 * 60 * 60)) % (60 * 60)) / 60),
          seconds: (((counter % (24 * 60 * 60)) % (60 * 60)) % 60)
        }
      })();
      const labelArr = labels?.split(',');
      setCounterSegments({
        "days": {
          "count": cData?.days || 0,
          "label": labelArr?.[0].trim(),
          "delim": ":"
        },
        "hours": {
          "count": cData?.hours || 0,
          "label": labelArr?.[1].trim(),
          "delim": ":"
        },
        "minutes": {
          "count": cData?.minutes || 0,
          "label": labelArr?.[2].trim(),
          "delim": ":"
        },
        "seconds": {
          "count": cData?.seconds || 0,
          "label": labelArr?.[3].trim()
        }
      });
    })()
    return () => clearInterval(timer);
  }, [counter, labels]);

  // const dateArray = [
  //   { startDate: "02/15/2025", targetDate: "02/19/2025" },
  //   { startDate: "02/19/2025", targetDate: "02/28/2025" },
  //   { startDate: "03/01/2025", targetDate: "03/19/2025" },
  //   { startDate: "03/25/2025", targetDate: "03/31/2025" },
  // ];

  // [{"startDate":"02/15/2025","targetDate":"02/19/2025" },{"startDate":"02/19/2025","targetDate":"02/28/2025 13:19:30"},{"startDate":"03/01/2025","targetDate":"03/19/2025"},{"startDate":"03/25/2025","targetDate":"03/31/2025" }]
  

  return (
    <>
    {/* Countdown: {counter} */}
    {/* <pre>{JSON.stringify(dates, null, 2)}</pre> */}
    {/* <pre>aDate--- {JSON.stringify(aDate, null, 2)}</pre> */}
    {/* <pre>counterStartDate --- {JSON.stringify(counterStartDate)}</pre> */}
    {/* <pre>jsonArray ---- {JSON.stringify(jsonArray, null, 2)}</pre> */}
    {/* <pre>datesJson ---- {JSON.stringify(JSON.parse(datesJson || "{}"), null, 2)}</pre> */}
    {/* {getCommingTargetDate({dateArray: JSON.parse(datesJson || "{}")})} */}
    {/* {targetDate} */}
    {/* <pre>{JSON.stringify(counterSegments, null, 2)}</pre> */}
      {!hide && enableCounter && <div className={classNames("Counter-container", variant)} data-testid="Counter">
        <div className={classNames("flex")}>
          {counterSegments && (Object?.keys(counterSegments) || [])?.map((ky: string)=>{
            return(
              <div key={`Counter--${ky}`} className={classNames("flex flex-row")}>
                <div className={classNames("flex flex-col items-center", counterSegmentWidth)}>
                  <span className={classNames("Counter-count", fontSize)}>
                    {counterSegments?.[ky]?.['count'] < 10 && counterSegments?.[ky]?.['count'] > -1 ? "0" + counterSegments?.[ky]?.['count'] : counterSegments?.[ky]?.['count']}
                  </span>
                  <label className={classNames("Counter-label uppercase", labelFontSize)}>{counterSegments?.[ky]?.['label']}</label>
                </div>
                
                {counterSegments?.[ky]?.['delim'] && <span className={classNames("Counter-delim", delimFontSize)}>{counterSegments?.[ky]?.['delim']}</span>}
              </div>
            )
          })}
        </div>
      </div>}
    </>
  );
};

export default Counter;
